// @shared:low — displayed when a user navigates to a doc page they cannot access
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function DocAccessDenied({ pageId }) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-5 px-6">
      <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center">
        <ShieldAlert size={28} className="text-red-400" />
      </div>

      <div className="text-center max-w-md space-y-2">
        <h2 className="text-lg font-semibold text-stone-800">
          Page inaccessible
        </h2>
        <p className="text-sm text-stone-500 leading-relaxed">
          Vous n'avez pas la permission de consulter cette page.
          Contactez le propriétaire de l'espace pour demander l'accès.
        </p>
      </div>

      <button
        onClick={() => navigate('/docs')}
        className="mt-2 inline-flex items-center gap-2 px-5 py-2.5 bg-stone-900 text-white rounded-xl text-sm font-medium hover:bg-stone-800 transition-colors cursor-pointer"
      >
        <ArrowLeft size={15} />
        Retour à la documentation
      </button>
    </div>
  );
}
